const defaultStaticColor = '#00aeef';

const palette = (colorPrimary = defaultStaticColor, colorMode = 'light') => {
  const isDark = colorMode === 'dark';

  return {
    type: colorMode,
    primary: {
      main: colorPrimary,
      light: colorPrimary,
      dark: colorPrimary,
      contrastText: '#ffffff',
      grey: isDark ? '#293241' : '#eeeeee',
      greyDark: isDark ? '#94a3b8' : '#c6c8c9',
      danger: '#F53434',
      success: '#4AB026',
      warning: '#F97032',
      green: '#81B214',
      orange: '#F58634'
    },
    secondary: {
      main: isDark ? '#94a3b8' : '#b1b1b1',
      light: isDark ? '#1f2937' : '#f2f2f2',
      dark: isDark ? '#e5e7eb' : '#333333',
      contrastText: '#ffffff',
      grey: isDark ? '#293241' : '#eeeeee',
      greyDark: isDark ? '#94a3b8' : '#c6c8c9',
      back: isDark ? '#111827' : '#F9F9F9',
      danger: '#F53434',
      success: '#4AB026',
      warning: '#F97032',
      green: '#81B214',
      orange: '#F58634'
    },
    background: {
      default: isDark ? '#0f172a' : '#fafafa',
      paper: isDark ? '#111827' : '#ffffff',
    },
    text: {
      primary: isDark ? '#f8fafc' : '#202124',
      secondary: isDark ? '#cbd5e1' : '#5f6368',
      disabled: isDark ? '#64748b' : '#a7a7a7',
    },
    divider: isDark ? '#293241' : '#eeeeee',
    action: {
      disabledBackground: isDark ? 'rgba(148, 163, 184, 0.18)' : 'rgba(0, 0, 0, 0.12)',
      disabled: isDark ? 'rgba(203, 213, 225, 0.38)' : 'rgba(0, 0, 0, 0.26)',
      hover: isDark ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0, 0, 0, 0.04)',
    },
  };
};

export default palette;
export { defaultStaticColor };
